import FORM_TYPE from '../../../../constants/FormType';

export const shouldShowLinkedGroupPicker = ({formType}) =>
    formType !== FORM_TYPE.selfService;
